// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5526) return "static/chunks/5526-5597c7f585ed2ca5.js";
	if (chunkId === 3964) return "static/chunks/3964-d9e05fff59475fc8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"87a6db885125b558","908":"25ae35b5d4e4eee3","1435":"b2a00bcd00f69615","4574":"658f1ea61548b6a8","4621":"a94918f9dbba0770","6227":"4f322f9f35bd905b","8608":"fc6d5bc3d11bb739","9777":"4a07d1040ff23b1c","9871":"dff9f1f0b9af06d6"}[chunkId] + ".js";
};